export default class AxiosErrorsMapper {
  translateError(error: any): string {
    switch (error?.response?.status) {
      case 401:
        return "Accesso negato, prova a ricaricare la pagina o ad accedere.";
      case 404:
        return "Risorsa non trovata";
      case 500:
        return "Si è verificato un errore interno.";
    }

    return "Si è verificato un errore";
  }
}
